import React, { Component, useState, useMemo } from "react";
import DefaultDataGrid from '../components/DefaultDataGrid';
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Box, CircularProgress, Grid, Fab } from '@mui/material';
import { Stack } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { query, flattenObj, unflattenObject } from '../App';
import InputColumn from '../components/InputColumn'
import InputRow from '../components/InputRow'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link, useNavigate, } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

export default function DefaultSite(props) {
    const [loading, setLoading] = React.useState(true);
    const [saving, setSaving] = React.useState(false);
    const [data, setData] = React.useState({});
    const { lookupId } = props;

    useMemo(() => {
        if (lookupId) {
            setLoading(true);
            return query(`${props.queryPath}?id=${lookupId}`, 'GET', undefined, alert = false).then(res => {
                res = flattenObj(res);
                console.log(res)
                setData(res);
                setLoading(false);
                props.dataReference({ ...res });
            })
        }
    }, [lookupId])

    const handleSave = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        let obj = {};
        for (const key of data.keys()) {
            obj[key] = data.get(key) === "true" ? true : data.get(key);
        }
        console.log(obj)
        setSaving(true);
        query(props.queryPath, 'PATCH', {
            id: lookupId,
            data: unflattenObject(obj)
        }).then(res => setSaving(false))
    }
    return (loading ? <CircularProgress /> :
        <Grid component="form" onSubmit={handleSave} columnSpacing={{ xs: 1, sm: 2, md: 3 }} item>
            <Grid xs={12} item className="container" sx={{ marginBottom: "20px" }} container alignItems={"center"}>
                <Button variant="contained" startIcon={<KeyboardReturnIcon />} component={Link} to={props.queryPath}>Cofnij</Button>
                <Typography variant="h6" textAlign="left" style={{ marginLeft: "10px" }}>
                    {props.title}
                </Typography>
            </Grid>
            {
                props.children
            }

            {
                !props.disableInputs && <Fab type="submit" color="primary" aria-label="add" sx={{ position: "fixed", left: "10px", bottom: "10px", height: "70px", width: "70px" }}>
                    {
                        <SaveIcon fontSize="large" />
                    }
                </Fab>
            }
        </Grid>)
}